import {makeObservable, observable, action} from 'mobx';

const INITIAL_SCORE = 0;

class WordSearchGameState {
    score = INITIAL_SCORE;

    constructor() {
        makeObservable(this, {
            score: observable,
            addPoint: action,
            reset: action,
        });
    }

    addPoint() {
        this.score++;
    }

    reset() {
        this.score = INITIAL_SCORE;
    }
}

export default WordSearchGameState;
